'use client';

import { useField } from 'formik';
import { Checkbox, type CommonCheckboxProps } from 'src/shared/ui/Checkbox';

type FieldCheckboxProps = Omit<CommonCheckboxProps, 'name'> & {
  name: string;
};

export const FieldCheckbox = ({ name, ...props }: FieldCheckboxProps) => {
  const [field, meta, helpers] = useField<boolean>(name);

  return (
    <Checkbox
      {...props}
      name={name}
      checked={field.value || false}
      onChange={(e, payload) => helpers.setValue(payload.checked)}
      error={meta.touched && meta.error ? meta.error : undefined}
    />
  );
};
